import type { JiraVersionDetailsCollapsedUi } from '@atlassian/jira-relay/src/__generated__/ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection.graphql';

export const checkIsCollapsed = (
	collapsedUis: readonly (JiraVersionDetailsCollapsedUi | null | undefined)[] | null | undefined,
	type: JiraVersionDetailsCollapsedUi,
): boolean => (collapsedUis ?? []).includes(type);
